import React from 'react';
import { Cta1, SubpageBanner } from '../components';
import { useTranslation } from 'react-i18next';

const KriptoRiskleri = () => {
    const { t } = useTranslation();

    return (
        <div className="subpage-content">
            {/* Page Banner */}
            <SubpageBanner 
                title={t('kriptoRiskleri.bannerTitle')}
                path="/nordex-academy"
            />

            <div className="academy-page">
                {/* Uyarı Mesajı - En Üstte */}
                <div className="academy-section">
                    <div className="container">
                        <div className="academy-highlight-box  text-white">
                            <h4 className="text-white">{t('kriptoRiskleri.warning.title')}</h4>
                            <p className="mb-0 fw-bold">{t('kriptoRiskleri.warning.text')}</p>
                        </div>
                    </div>
                </div>

                {/* Giriş */}
                <div className="academy-intro-section py-5">
                    <div className="container">
                        <h3 className="academy-subtitle">{t('kriptoRiskleri.subtitle')}</h3>
                        <p className="academy-intro-text">{t('kriptoRiskleri.intro.p1')}</p>
                        <p className="academy-intro-text fw-bold">{t('kriptoRiskleri.intro.p2')}</p>
                        <ul className="academy-list">
                            {t('kriptoRiskleri.intro.items', { returnObjects: true }).map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Bölüm 1: Piyasa Riskleri */}
                <div className="academy-section mt-5 mb-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('kriptoRiskleri.section1.title')}</h2>
                        
                        {t('kriptoRiskleri.section1.risks', { returnObjects: true }).map((risk, index) => (
                            <div className="academy-highlight-box mb-4" key={index}>
                                <h4>{risk.title}</h4>
                                <p>{risk.description}</p>
                                
                                {risk.examples && (
                                    <div className="academy-example-box mt-3">
                                        <strong>{t('kriptoRiskleri.section1.examplesLabel')}</strong>
                                        <ul className="mb-0">
                                            {risk.examples.map((example, eIdx) => (
                                                <li key={eIdx}>{example}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}

                                {risk.reasons && (
                                    <div className="mt-3">
                                        <strong>{t('kriptoRiskleri.section1.reasonsLabel')}</strong>
                                        <ul>
                                            {risk.reasons.map((reason, rIdx) => (
                                                <li key={rIdx}>{reason}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}

                                {risk.protection && (
                                    <div className="academy-highlight-box bg-success text-white mt-3">
                                        <strong className="text-white">{t('kriptoRiskleri.section1.protectionLabel')}</strong>
                                        <ul className="mb-0 mt-2">
                                            {risk.protection.map((item, pIdx) => (
                                                <li key={pIdx}>{item}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Bölüm 2: Dolandırıcılık Riskleri */}
                <div className="academy-section mt-5 mb-5">
                    <div className="container">
                        <h2 className="academy-section-title text-danger">{t('kriptoRiskleri.section2.title')}</h2>
                        <div className="academy-highlight-box  text-white">
                            <h5 className="text-white">{t('kriptoRiskleri.section2.warningTitle')}</h5>
                        </div>
                        
                        {t('kriptoRiskleri.section2.scams', { returnObjects: true }).map((scam, index) => (
                            <div className="academy-type-card mb-4 border-danger" key={index}>
                                <h4 className="text-danger">{scam.type}</h4>
                                <p>{scam.description}</p>
                                
                                <div className="mt-3">
                                    <strong>{t('kriptoRiskleri.section2.howItHappensLabel')}</strong>
                                    <ol>
                                        {scam.howItHappens.map((step, sIdx) => (
                                            <li key={sIdx}>{step}</li>
                                        ))}
                                    </ol>
                                </div>

                                {scam.realCase && (
                                    <div className="academy-example-box  text-white mt-3">
                                        <strong className="text-white">{t('kriptoRiskleri.section2.realCaseLabel')}</strong>
                                        <ul className="mt-2 mb-0">
                                            {scam.realCase.map((item, rIdx) => (
                                                <li key={rIdx}>{item}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}

                                <div className="academy-highlight-box bg-success text-white mt-3">
                                    <strong className="text-white">{t('kriptoRiskleri.section2.protectionLabel')}</strong>
                                    <ul className="mb-0 mt-2">
                                        {scam.protection.map((item, pIdx) => (
                                            <li key={pIdx}>{item}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Bölüm 3: Teknik Riskler */}
                <div className="academy-section mt-5 mb-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('kriptoRiskleri.section3.title')}</h2>
                        
                        {t('kriptoRiskleri.section3.risks', { returnObjects: true }).map((risk, index) => (
                            <div className="academy-highlight-box mb-4" key={index}>
                                <h4>{risk.title}</h4>
                                <p>{risk.description}</p>
                                
                                {risk.examples && (
                                    <div className="academy-example-box mt-3">
                                        <strong>{t('kriptoRiskleri.section3.examplesLabel')}</strong>
                                        <ul className="mb-0">
                                            {risk.examples.map((example, eIdx) => (
                                                <li key={eIdx}>{example}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}

                                <div className="academy-highlight-box bg-success text-white mt-3">
                                    <strong className="text-white">{t('kriptoRiskleri.section3.protectionLabel')}</strong>
                                    <ul className="mb-0 mt-2">
                                        {risk.protection.map((item, pIdx) => (
                                            <li key={pIdx}>{item}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Bölüm 4: Düzenleme Riskleri */}
                <div className="academy-section mt-5 mb-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('kriptoRiskleri.section4.title')}</h2>
                        <p className="academy-section-text">{t('kriptoRiskleri.section4.intro')}</p>
                        
                        <div className="row g-4">
                            {t('kriptoRiskleri.section4.risks', { returnObjects: true }).map((risk, index) => (
                                <div className="col-md-6" key={index}>
                                    <div className="academy-type-card">
                                        <h5>{risk.title}</h5>
                                        <p className="mb-0">{risk.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Bölüm 5: Psikolojik Riskler */}
                <div className="academy-section mt-5 mb-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('kriptoRiskleri.section5.title')}</h2>
                        <p className="academy-section-text fw-bold">{t('kriptoRiskleri.section5.intro')}</p>
                        
                        {t('kriptoRiskleri.section5.risks', { returnObjects: true }).map((risk, index) => (
                            <div className="academy-highlight-box mb-3" key={index}>
                                <h5>{risk.title}</h5>
                                <p className="mb-0">{risk.description}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Bölüm 6: Güvenli Yatırım İlkeleri */}
                <div className="academy-section mt-5 mb-5">
                    <div className="container">
                        <h2 className="academy-section-title text-success">{t('kriptoRiskleri.section6.title')}</h2>
                        
                        {t('kriptoRiskleri.section6.principles', { returnObjects: true }).map((principle, index) => (
                            <div className="academy-step-card mb-3">
                                <div className="step-content">
                                    <h4>{principle.title}</h4>
                                    <p className="fw-bold">{principle.subtitle}</p>
                                    <p>{principle.description}</p>
                                    
                                    {principle.examples && (
                                        <div className="academy-example-box mt-3">
                                            {principle.examples.map((example, eIdx) => (
                                                <p key={eIdx} className="mb-2">{example}</p>
                                            ))}
                                        </div>
                                    )}

                                    {principle.approach && (
                                        <div className="mt-3">
                                            <strong>{principle.approach.title}</strong>
                                            <ul className="mb-0">
                                                {principle.approach.items.map((item, iIdx) => (
                                                    <li key={iIdx}>{item}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Özet */}
                <div className="academy-summary-section mt-5 mb-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('kriptoRiskleri.summary.title')}</h2>
                        <p className="academy-section-text">{t('kriptoRiskleri.summary.intro')}</p>
                        
                        <div className="academy-type-card mt-4">
                            <h5>{t('kriptoRiskleri.summary.mainRisks.title')}</h5>
                            <ol>
                                {t('kriptoRiskleri.summary.mainRisks.items', { returnObjects: true }).map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ol>
                        </div>

                        <div className="academy-type-card mt-4">
                            <h5>{t('kriptoRiskleri.summary.protectionWays.title')}</h5>
                            <ul className="mb-0">
                                {t('kriptoRiskleri.summary.protectionWays.items', { returnObjects: true }).map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>
                        </div>

                        <div className="academy-highlight-box mt-4">
                            <h5>{t('kriptoRiskleri.summary.remember.title')}</h5>
                            <p className="mb-0 fw-bold">{t('kriptoRiskleri.summary.remember.text')}</p>
                        </div>

                        <div className="academy-highlight-box  text-white mt-4">
                            <h5 className="text-white">{t('kriptoRiskleri.summary.finalWarning.title')}</h5>
                            <p className="mb-0">{t('kriptoRiskleri.summary.finalWarning.text')}</p>
                        </div>
                    </div>
                </div>
            </div>

            <Cta1 
            title={<><span style={{color: '#31cce5' }}>{t('home.ctaInvestment')}</span> {t('home.ctaTitle')}</>}
                subtitle={<span>{t('home.ctaSubtitle')}</span>}/>
        </div>
    );
};

export default KriptoRiskleri;
